import Link from 'next/link';
import Image from 'next/image';
import React, { useState } from 'react';
import clsx from 'clsx';
import { addBaseUrl, removeBaseUrl } from '@/utils/url';
import { WagtailPage, WagtailStreamfieldImage } from '@/types';
// import Link from 'next/link';
import RawHtml from '@components/RawHtml';

type PvOfferType = {
  text: string;
  title: string;
  limit_kWp: string;
  included_parts: string;
  details: string;
  price: string;
  vat: string;
};

type Props = {
  title?: string;
  text?: string;
  bottomtext?: string;
  pv_offers: PvOfferType[];
};

function PvOffers(props: Props) {
  const { pv_offers: pvOffers, title, text, bottomtext } = props;

  const [showMore, setShowMore] = useState(false);
  let offers = pvOffers.slice(0, 3);
  if (showMore) {
    offers = pvOffers;
  }

  return (
    <div className='pv-offers streamfield'>
      {title ? <h2 className='cards__title'>{title}</h2> : null}
      {text ? <RawHtml html={text} className='pv-offers__text' /> : null}
      <div className='pv-offers__container'>
        {offers.map(item => (
          <div className='pv-offers__card' key={item.title}>
            <h3 className='pv-offers__card-title'>{item.title}</h3>
            {item.limit_kWp ? (
              <RawHtml html={item.limit_kWp} className='pv-offers__card-kwp-limit' />
            ) : null}
            {item.included_parts ? (
              <RawHtml html={item.included_parts} className='pv-offers__card-parts' />
            ) : null}
            {item.details ? (
              <RawHtml html={item.details} className='pv-offers__card-details' />
            ) : null}
            {item.price ? <RawHtml html={item.price} className='pv-offers__card-price' /> : null}
            {item.vat ? <RawHtml html={item.vat} className='pv-offers__card-vat' /> : null}
          </div>
        ))}
      </div>
      <div className='pv-offers__button-container'>
        <button className='button card__link' onClick={() => setShowMore(!showMore)}>
          {!showMore ? 'Mehr anzeigen' : 'Weniger Anzeigen'}
        </button>
      </div>
      {bottomtext ? <RawHtml html={bottomtext} className='pv-offers__bottom-text' /> : null}
    </div>
  );
}

export default PvOffers;
